import React, { Component } from "react";
import { IoDocumentsSharp } from "react-icons/io5";
import { GrDocumentExcel } from "react-icons/gr";
import axios from "axios";
import { MdOutlineFileDownload } from "react-icons/md";
import { CiLock } from "react-icons/ci";
import LoadingError from "../loading_error";



class DocumentCourse extends Component {
    state = {
        course: [],
        loading : false
    }

    componentDidMount() {
        this.setState({course: this.props.course})
    }
    componentDidUpdate(prevProps) {
        if (this.props.course !== prevProps.course) {
            this.setState({course: this.props.course})
            // this.fetchCourses();
        }
    }
    // fetchCourses = async () => {
    //     const accessToken = localStorage.getItem("accessToken");
    //     try {
    //         const course_id = this.props.course_id
    //         const courseId = parseInt(course_id, 10);
    //         let headers = {}; // Initialize an empty headers object

    //         if (accessToken) {
    //             headers = {
    //                 Authorization: `Bearer ${accessToken}`,
    //             };
    //         }
        
    //         const response = await axios.get("https://api.geoinfoacademy.com/api/courses/" + courseId, {
    //             headers: headers,
    //         });
    //         this.setState({ course: response.data });
    //         console.log("API Response:", response.data);
    //     } catch (error) {
    //         console.error("Error fetching data:", error);
    //     }
    // };

    handleDownload = async (doc) => {
        this.setState({loading: true})
        const accessToken = localStorage.getItem("accessToken");
        const documentId = doc.id;

        try {
            const response = await axios.get(`https://api.geoinfoacademy.com/api/download/document/${documentId}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                responseType: 'blob',
            });
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // Get the content type from the response
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            let filename = doc.title;

            const contentDisposition = response.headers['content-disposition'];

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (filenameMatch) {
                    filename = filenameMatch[1];
                }
            } else if (doc.file_path) {
                try {
                    const url = new URL(doc.file_path);
                    const pathname = url.pathname;
                    const ext = pathname.substring(pathname.lastIndexOf('.') + 1);

                    if (ext) {
                        filename = `${doc.title}.${ext}`;
                    } else {
                        console.warn("Could not determine extension from doc.file_path:", doc.file_path);
                    }

                } catch (error) {
                    console.error("Error parsing doc.file_path:", doc.file_path, error);
                }
            } else {
                console.warn("Neither Content-Disposition nor doc.file_path available for filename.");
            }


            link.setAttribute('download', filename); // Set the filename
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            this.setState({loading: false})
        } catch (error) {
            console.error("Error downloading file:", error);
            this.setState({loading: false})
        }
    };

//     handleDownload = (doc) => {
//     const documentId = doc.id;
//     const accessToken = localStorage.getItem("accessToken");
    
//     // Construct the URL with the token as a query param (if your backend supports it)
//     const downloadUrl = `https://api.geoinfoacademy.com/api/download/document/${documentId}/?token=${accessToken}`;
    
//     const link = document.createElement('a');
//     link.href = downloadUrl;
//     link.setAttribute('download', doc.title || 'file');
//     document.body.appendChild(link);
//     link.click();
//     link.remove();
// };



    handleRedirect = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        if (accessToken) {
            // Navigate if already logged in
         
        try {
            const response = await axios.post(
                `https://api.geoinfoacademy.com/api/interested-courses/`,
                {
                    course_id: course_id, // Place course_id in the request body
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            console.log(response.data.message)
            window.location.href = `/description/${course_id}/paymentverify`; 
        }
        catch (error) {
            console.error("Error initiating payment:", error);
        }

    }else {
            localStorage.setItem('redirectCourseId', course_id); // Store course ID
            localStorage.setItem('redirectCourseaction', "apply");
            window.location.href = '/login'; // Redirect to login
        }
    };



    render() {
        const {loading} = this.state
        const document = this.state.course;
        const doclist = document && document.documents && document.documents.length ? (
            document.documents.map((doc) => {
                const fileName = doc.file_path.substring(doc.file_path.lastIndexOf('/') + 1);
                const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1); // Extract the extension
                return (
                    <li className="document" key={doc.id}>
                        <IoDocumentsSharp /> <span>{doc.title}</span> <span className="file-extension">{fileExtension}</span><button onClick={() => this.handleDownload(doc)} className="download"><MdOutlineFileDownload /></button>
                    </li>
                );
            })
        ) : (
            <li className="document">
                <GrDocumentExcel /> No Document
            </li>
        );

        return (
            <>
            <section className="document_cover" >
                <h3>Document for course</h3>
                {this.state.course.enrolled !== true ?
                    <div className="enroll_error">
                        <div className="enroll_cover">
                            <CiLock />
                            <p>Enroll For Course To Gain Access</p>
                            <button onClick={this.handleRedirect}>Apply For Course</button>
                        </div>
                    </div>

                    : doclist}
            </section>
            {loading ? <LoadingError /> : null}
            </>
        )
    }
}

export default DocumentCourse